'use strict';

import style from './audio-player.style';


export class AudioPlayer extends HTMLElement {
  constructor(self) {
    self = super(self);
    self.init.call(self);
  }
  init() {
    this._isPlaying = false;
    this._isDown = false;

    this._time = 0;
    this._duration = 0;
    this._progress = 0;

    this._progressWidth = 0;
    this._progressLeft = 0;

    this._src = '';

    this._titleContainer = document.createElement('div');
    this._titleContainer.classList.add('audio_title-inner');
    this._titleInner = document.createElement('span');
    this._durationInner = document.createElement('span');

    this._titleInner.innerHTML = this.getAttribute('title');
    this._durationInner.innerHTML = '00.00';

    this._audio = document.createElement('audio');
    this._audio.style.display = 'none';
    this._audio.setAttribute('type', this.getAttribute('type'));
    this.src = this.getAttribute('src');



    this._audioContainer = document.createElement('div');
    this._audioContainer.classList.add('audio_container');

    this._button = document.createElement('button');
    this._button.classList.add('audio_button');
    this._playIcon = document.createElement('span');
    this._playIcon.classList.add('audio_play-icon');
    this._pauseIcon = document.createElement('span');
    this._pauseIcon.classList.add('audio_pause-icon');

    this._button.appendChild(this._playIcon);

    this._progressContainer = document.createElement('div');
    this._progressContainer.setAttribute('tabindex', '0');
    this._progressContainer.classList.add('audio_progress-container');
    this._progressLine = document.createElement('div');
    this._progressLine.classList.add('audio_progress-line');
    this._progressLineInner = document.createElement('div');
    this._progressLineInner.classList.add('audio_progress-line-inner');
    this._progressLine.appendChild(this._progressLineInner);
    this._progressContainer.appendChild(this._progressLine);



    this._titleContainer.appendChild(this._titleInner);
    this._titleContainer.appendChild(this._durationInner);

    this._audioContainer.appendChild(this._button);
    this._audioContainer.appendChild(this._progressContainer);

    this._upMethod = e => this._up(e);
    this._moveMethod = e => {
      if (!this._isDown) return;

      e.preventDefault()
      this._move(e.clientX);
    }
    this._touchmoveMethod = e => {
      if (!this._isDown) return;

      e.preventDefault()
      this._move(e.touches[0].clientX);
    }

    this.onResize = (e) => this._onResize(e);
  }
  connectedCallback() {
    this._shadow = this.attachShadow({mode: 'open'});

    this._shadow.innerHTML = style;
    this._shadow.appendChild(this._audio);
    this._shadow.appendChild(this._titleContainer);
    this._shadow.appendChild(this._audioContainer);

    this._audio.addEventListener('loadedmetadata', (e) => {
      this._duration = this._audio.duration;

      this._durationInner.innerHTML = (Math.floor(this._duration) / 100).toFixed(2);
    });
    this._audio.addEventListener('timeupdate', (e) => {
      this._time = this._audio.currentTime;
      this._progress = this._time / this._duration;
      this._setProgress();
    });
    this._audio.addEventListener('pause', (e) => {
      this._isPlaying = false;
      this._button.removeChild(this._pauseIcon);
      this._button.appendChild(this._playIcon);
    });
    this._audio.addEventListener('play', (e) => {
      this._isPlaying = true;
      this._button.removeChild(this._playIcon);
      this._button.appendChild(this._pauseIcon);
    });

    this._button.addEventListener('click', (e) => {
      if (this._audio.paused) {
        this.play();
      } else {
        this.pause();
      }
    });

    this._progressContainer.addEventListener('keydown', (e) => {
      e.preventDefault();

      let time = 0;
      if (e.key === 'ArrowLeft') {
        time = -5;
      } else if (e.key === 'ArrowRight') {
        time = 5;
      } else {
        return;
      }

      this._audio.currentTime = Math.min(this._duration, Math.max(0, this._audio.currentTime + time));
    });

    this._progressContainer.addEventListener('mousedown', (e) => {
      if (!this._duration) return;
      this._down(e);
      this._move(e.clientX);
      this._progressContainer.focus();
    });
    document.documentElement.addEventListener('mouseup', this._upMethod);
    document.documentElement.addEventListener('mousemove', this._moveMethod);

    this._progressContainer.addEventListener('touchstart', (e) => {
      if (!this._duration) return;
      this._down(e);
      this._move(e.touches[0].clientX);
    });
    document.documentElement.addEventListener('touchend', this._upMethod);
    document.documentElement.addEventListener('touchcancel', this._upMethod);
    document.documentElement.addEventListener('touchmove', this._touchmoveMethod, { passive: false });

    this._onResize();
    window.addEventListener('resize', this.onResize);

    this._setProgress();
  }
  attributeChangedCallback(name, oldValue, newValue) {
    if (name === 'src') {
      this.src = newValue;
    } else if (name === 'title') {
      this.title = newValue;
    }
  }
  disconnectedCallback() {
    document.documentElement.removeEventListener('mouseup', this._upMethod);
    document.documentElement.removeEventListener('mousemove', this._moveMethod);

    document.documentElement.removeEventListener('touchend', this._upMethod);
    document.documentElement.removeEventListener('touchcancel', this._upMethod);
    document.documentElement.removeEventListener('touchmove', this._touchmoveMethod);

    window.removeEventListener('resize', this.onResize);
  }

  _setProgress(progress = this._progress) {
    this._progressLine.style.transform = `translate3d(-${(1 - progress) * 100}%, 0, 0)`;
    this._progressLineInner.style.transform = `translate3d(${(1 - progress) * 100}%, 0, 0)`;
  }
  static get observedAttributes() {
    return ['src', 'title'];
  }
  _onResize() {
    const bounds = this._progressContainer.getBoundingClientRect();
    this._progressWidth = bounds.width;
    this._progressLeft = bounds.left;
  }
  _down(e) {
    e.preventDefault();
    this._isDown = true;
    this.pause()
  }
  _up(e) {
    if (!this._isDown) return;

    e.preventDefault();
    this._isDown = false;
    this.play()
  }
  _move(x) {
    let coefficient = (x - this._progressLeft) / this._progressWidth;
    coefficient = Math.min(1, Math.max(0, coefficient));

    this._audio.currentTime = coefficient * this._duration;
  }


  set src(src /* string */) {
    if (!src) {
      throw new Error('Где путь до .mp3?');
    }

    if (this._src === src) return;

    if (!this._audio.paused) {
      this._isPlaying = false;
      this._button.removeChild(this._pauseIcon);
      this._button.appendChild(this._playIcon);
      this.pause();
    }

    this._audio.src = src;
    this._progress = -0.01;
    this._src = src;
  }
  set title(title /* string */) {
    this._titleInner.innerHTML = title;
    // this.setAttribute('title', title);
  }


  play() {
    this._audio.play();
    // this._isPlaying = true;
  }
  pause() {
    this._audio.pause();
    // this._isPlaying = false;
  }
}


window.customElements.define('audio-player', AudioPlayer);